import { render, staticRenderFns } from "./cop.vue?vue&type=template&id=7d88431c&"
import script from "./cop.vue?vue&type=script&lang=js&"
export * from "./cop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports